// РФ-формат без Intl-локали (детерминизм в тестах): "1 234,56 ₽", неразрывный пробел как разделитель тысяч.
export function formatKopecks(kopecks: number): string {
  const sign = kopecks < 0 ? "-" : "";
  const abs = Math.abs(Math.trunc(kopecks));
  const rub = Math.trunc(abs / 100);
  const kop = abs % 100;
  const rubStr = String(rub).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${sign}${rubStr},${String(kop).padStart(2, "0")} ₽`;
}
